export const isImpersonationCallbackPath = path =>
	/^\/auth\/impersonate\/?$/.test(path || '')
